import { HStack, Icon, Link, Spacer } from "@chakra-ui/react";
import { LuExternalLink } from "react-icons/lu";
import { TbBook } from "react-icons/tb";
import { useLocation } from "react-router-dom";

import { Links } from "../constants";
import { pageDocsLink } from "../links";

// DocsFooter links to the documentation of the current page, along with the docs home
export function DocsFooter(props) {
    const location = useLocation()
    const pageDoc = pageDocsLink(location.pathname, location.search)
    return (
        <HStack as="footer" fontSize="sm" color="fg.muted" gap="4" flexWrap="wrap" {...props}>
            {pageDoc && (
                <Link href={pageDoc.url} target="_blank" rel="noopener noreferrer" color="fg.muted">
                    <Icon as={TbBook} /> Learn more: {pageDoc.title}
                </Link>
            )}
            <Spacer />
            <Link href={Links.DocsURL} target="_blank" rel="noopener noreferrer" color="fg.muted">
                All docs <LuExternalLink />
            </Link>
        </HStack>
    )
}
